import { network, logger, laravelApiV1 } from "./index";
import { DataDef } from "./data";
import { Estate } from "../models/Estate";
import { UserProfile, UserProfileJSON } from "../models/UserProfile";
import { CognitoAuth } from "./CognitoAuth";
import { Language, LanguageJson } from "../models/Langauges";
import { Subscription } from "../models/Subscription";
import { AssetCategory, AssetCategoryJSON } from "../models/AssetCategory";
import { isLead } from "../constants"

export class AtticusMySQL {
  static async getLanguages(): Promise<Language[] | undefined> {
    try {
      const path = Language.path;
      const response = await network.callGet(path, true, {
        baseURL: laravelApiV1,
      });
      return response?.data.map((json: LanguageJson) =>
        Language.fromJSON(json)
      );
    } catch (error) {
      !isLead && CognitoAuth.handleError(error, "getLanguages error");
    }
  }

  static async getSubscription(): Promise<Subscription | undefined> {
    try {
      const path = "/subscription";
      const response = await network.callGet(path, true, {
        baseURL: laravelApiV1,
      });
      return Subscription.fromJSON(response?.data?.message);
    } catch (error) {
      !isLead && CognitoAuth.handleError(error, "getSubscription error");
    }
  }

  static async updateUserProfile(
    updateFields: UserProfileJSON
  ): Promise<boolean> {
    try {
      await network.callPut(UserProfile.path + "/me", updateFields);
      return true;
    } catch (error) {
      !isLead && CognitoAuth.handleError(error, "updateUserProfile error");
      throw error;
    }
  }

  static async getEstate(estateId: number): Promise<Estate | null> {
    try {
      const response = await network.callGet(
        Estate.path + "/" + estateId,
        true
      );
      if (response?.data) {
        return Estate.fromJSON(response.data);
      } else {
        logger.error("no response.data", false);
      }
      // empty user indicates not authenticated or error
      return null;
    } catch (error) {
      !isLead && CognitoAuth.handleError(error, "getEstate error");
      return null;
    }
  }

  static async getAssetCategories(): Promise<AssetCategory[]> {
    const response = await network.callGet("categories-subcategories", false, {
      baseURL: laravelApiV1,
    });
    return response?.data?.map((json: AssetCategoryJSON) =>
      AssetCategory.fromJSON(json)
    );
  }

  // TODO: clean up - is this used anymore?
  static async getScreenData(
    screenData: DataDef,
    id?: number | string
  ): Promise<Record<string, string | number | boolean> | undefined> {
    // TODO: implement client-side caching
    let data;
    const response = await network.callGet(
      `${screenData.api}${id ? "/" + id : null}`
    );
    // console.log(`response.data: ${JSON.stringify(response?.data)}`);
    if (response) {
      data = response.data;
    } else {
      console.error(`data request for ${screenData.api} failed`);
    }
    if (screenData.fields.includes("firstName")) {
      data = {
        firstName: "Jim",
      };
    }
    return data;
  }

  // TODO: clean up - is this used anymore?
  static async saveScreenData(
    screenData: DataDef,
    id?: number | string,
    dataToSave?: Record<string, string | number | boolean>
  ): Promise<boolean> {
    if (!dataToSave || !id) return false;
    try {
      const response = await network.callPost(
        `${screenData.api}/${id}`,
        dataToSave
      );
      // const response = isNew
      //   ? await network.callPost(`${screenData.api}/me`, dataToSave)
      //   : await network.callPut(`${screenData.api}/me`, dataToSave);
      console.log(`response.data: ${JSON.stringify(response?.data)}`);
      return true;
    } catch (error) {
      return false;
    }
  }
}
